<script>
    import { _ } from "svelte-i18n";
    import Checkbox from "../Checkbox.svelte";
    import DatePicker from "../DatePicker.svelte";
    import Editor from "../Editor.svelte";
    import Select from "../Select.svelte";
    import { slide } from "svelte/transition";
    import { FieldType } from "../../common/constants";
    import AssetPicker from "../assets/AssetPicker.svelte";
    import DocPicker from "../DocPicker.svelte";

    export let field;
    export let value;
    export let error = "";
    export let valid;

    const getWidth = (width) => {
        const toCalculate = width || "1";
        const [term, divider = 1] = toCalculate
            .split("/")
            .map((it) => parseInt(it.trim()));
        return (term / divider) * 100;
    };

    $: width = getWidth(field.width);

    let hasBeenEdited = false;

    const checkForErrors = (hasBeenEdited, field, value) => {
        if (!hasBeenEdited) return "";
        const validation = field.validator && field.validator(value);
        if (validation) return validation;
        if (field.required && (!value || value === "<p><br></p>"))
            return "Form.FieldRequired";
        return "";
    };

    const checkIfValid = (field, value) => {
        const validation = field.validator && field.validator(value);
        if (validation) return false;
        if (field.required && (!value || value === "<p><br></p>")) return false;
        return true;
    };

    $: error = checkForErrors(hasBeenEdited, field, value);

    $: valid = checkIfValid(field, value);
</script>

<div class="flex flex-col p-2" style={`width: ${width}%;`}>
    {#if field.label}
        <span class={field.class}
            >{$_(field.label)}
            {#if field.required}{" *"}{/if}
        </span>
    {/if}

    {#if field.type === FieldType.TEXT}
        <input
            type="text"
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            bind:value
            required={field.required}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.NUMBER}
        <input
            type="number"
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            bind:value
            required={field.required}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.EMAIL}
        <input
            type="email"
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            bind:value
            required={field.required}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.PRICE}
        <input
            type="number"
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            bind:value
            required={field.required}
            min={0}
            step={0.01}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.PHONE}
        <input
            type="tel"
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            bind:value
            required={field.required}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.TEXTAREA}
        <textarea
            bind:value
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            required={field.required}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.INFO}
        {#if field.title}<span class={field.class}>{field.title}</span>{/if}
    {:else if field.type === FieldType.CHECKBOX}
        <Checkbox bind:value on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.SELECT}
        <Select let:option bind:value options={field.values}>
            <span slot="value" let:selected>{$_(selected.text)}</span>
            <span>{$_(option.text)}</span>
        </Select>
    {:else if field.type === FieldType.HTML}
        <Editor
            bind:value
            placeholder={field.placeholder ? $_(field.placeholder) : ""}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.DATE}
        <DatePicker bind:value on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.ASSET}
        <AssetPicker
            bind:value
            multiple={field.multiple}
            filter={field.filter}
            on:change={() => (hasBeenEdited = true)} />
    {:else if field.type === FieldType.REFERENCE}
        <DocPicker
            bind:value
            multiple={field.multiple}
            form={field.form}
            collection={field.collection}
            on:change={() => (hasBeenEdited = true)} />
    {/if}

    {#if error}<span transition:slide class="text-fred">{$_(error)}</span>{/if}
</div>
